
const newModel = () => {
    return {
        truongchuanQuocgiaPhonghocId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,
        ghiChu: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaPhonghocId: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaPhonghocId: item.truongchuanQuocgiaPhonghocId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaPhonghocId: item.truongchuanQuocgiaPhonghocId,
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruongchuanQuocgia: item.tenTruongchuanQuocgia,
        idKy: item.idKy,
        tenKy: item.tenKy,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        truongchuanQuocgiaId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaPhonghocId: null,
        truongchuanQuocgiaId: null,
        tenTruongchuanQuocgia: null,
        idKy: null,
        tenKy: null,
        tongsoPhong: null,
        phongKienco: null,
        phongBankienco: null,
        phongTam: null,
        ghiChu: null,
        enabled: null,
    }
}

export const truongchuanQuocgiaPhonghocModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


